(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Testimony"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('testimonialSlider');
  if (!slider) return;

  // Only apply slider behavior for tablet/mobile
  const isDesktop = window.matchMedia("(min-width: 1024px)").matches;
  if (isDesktop) return;

  const items = slider.querySelectorAll('.testimonies__item');
  if (items.length <= 1) return; // No need for slider with 1 item

  // Clone first item and append to end for infinite loop
  const firstItem = items[0].cloneNode(true);
  firstItem.classList.add('clone');
  slider.appendChild(firstItem);

  let currentIndex = 0;
  const itemWidth = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);
  let isAnimating = false;
  let autoScrollInterval;

  function goToSlide(index) {
    if (isAnimating) return;
    isAnimating = true;
    
    slider.style.scrollBehavior = 'smooth';
    slider.scrollTo({
      left: index * itemWidth,
      behavior: 'smooth'
    });
    
    setTimeout(() => {
      // If we're at the clone, instantly reset to first item without animation
      if (index >= items.length) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        currentIndex = 0;
      }
      isAnimating = false;
    }, 500);
  }

  function startAutoScroll() {
    autoScrollInterval = setInterval(() => {
      currentIndex++;
      goToSlide(currentIndex);
    }, 3000);
  }

  // Start auto-scrolling
  startAutoScroll();

  // Pause on hover/touch
  slider.addEventListener('mouseenter', () => {
    clearInterval(autoScrollInterval);
  });

  slider.addEventListener('mouseleave', () => {
    startAutoScroll();
  });

  // Handle touch events
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
    clearInterval(autoScrollInterval);
  }, {passive: true});

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
    startAutoScroll();
  }, {passive: true});

  function handleSwipe() {
    const threshold = 50;
    if (touchStartX - touchEndX > threshold) {
      // Swipe left - next slide
      currentIndex++;
      goToSlide(currentIndex);
    } else if (touchEndX - touchStartX > threshold) {
      // Swipe right - previous slide
      currentIndex = Math.max(0, currentIndex - 1);
      goToSlide(currentIndex);
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["beauty-results"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-brand"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-treatments"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var targets = section.querySelectorAll('.fade-in-target');
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    targets.forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["house-feature"] && !Shopify.designMode) return;
  try {
    
  function initParallaxHouse() {
    const section = document.querySelector('.js-parallax-section');
    const imgUp = document.querySelector('.js-parallax-up');
    const imgDown = document.querySelector('.js-parallax-down');

    if (!section || !imgUp || !imgDown) return;

    const handleScroll = () => {
      const sectionRect = section.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const sectionCenter = sectionRect.top + (sectionRect.height / 2);
      const viewportCenter = windowHeight / 2;
      const distanceFromCenter = viewportCenter - sectionCenter;

      if (sectionRect.top < windowHeight && sectionRect.bottom > 0) {
        const speed = 0.15;
        const movement = distanceFromCenter * speed;
        imgUp.style.transform = `translateY(${-movement}px)`;
        imgDown.style.transform = `translateY(${movement}px)`;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
  }

  document.addEventListener('DOMContentLoaded', initParallaxHouse);
  document.addEventListener('shopify:section:load', initParallaxHouse);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function () {
    var root = document.querySelector('.g-cart');
    if (!root) return;
    var form = root.querySelector('form#cart');
    function post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); });
    }
    /* Quantity changes apply immediately (no "update" button) */
    var timer;
    function change(line, qty) {
      root.classList.add('is-busy');
      post(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/change.js' : '/cart/change.js', { id: line, quantity: qty })
        .then(function () { window.location.reload(); })
        .catch(function () { root.classList.remove('is-busy'); });
    }
    root.querySelectorAll('[data-cart-line]').forEach(function (box) {
      var input = box.querySelector('[data-cart-qty]');
      box.querySelectorAll('[data-cart-step]').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(b.getAttribute('data-cart-step'), 10));
          input.value = v;
          clearTimeout(timer); timer = setTimeout(function () { change(box.getAttribute('data-cart-line'), v); }, 350);
        });
      });
      input.addEventListener('change', function () {
        change(box.getAttribute('data-cart-line'), Math.max(0, parseInt(input.value, 10) || 0));
      });
    });
    if (form) form.addEventListener('keydown', function (e) { if (e.key === 'Enter' && e.target.matches('[data-cart-qty]')) { e.preventDefault(); e.target.blur(); } });

    /* Upsell */
    var up = root.querySelector('[data-cart-upsell]');
    if (!up || !up.getAttribute('data-product-id')) return;
    var cfg = {};
    try { cfg = JSON.parse(document.querySelector('[data-gcd-config]').textContent); } catch (e) {}
    var inCart = {};
    root.querySelectorAll('[data-cart-line]').forEach(function (b) { inCart[b.getAttribute('data-cart-line').split(':')[0]] = true; });
    function money(c) { return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(c) : (c / 100).toFixed(2) + ' dh'; }
    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
    var pid = up.getAttribute('data-product-id');
    var base = (cfg.routes && cfg.routes.recommendations) || '/recommendations/products.json';
    fetch(base + '?product_id=' + pid + '&limit=8&intent=related')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var list = (d.products || []).filter(function (p) { return p.available && !inCart[p.variants[0].id]; }).slice(0, 3);
        if (!list.length) return;
        up.querySelector('[data-cart-upsell-list]').innerHTML = list.map(function (p) {
          var v = p.variants.filter(function (x) { return x.available; })[0] || p.variants[0];
          var img = p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' : '') + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
          return '<li class="g-cart__up"><a href="' + esc(p.url) + '"><img src="' + esc(img) + '" alt="" loading="lazy" width="72" height="90"></a>' +
            '<div><a class="g-cart__up-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a><span class="g-cart__up-price">' + money(v.price) + '</span>' +
            '<button type="button" class="g-cart__up-add" data-cart-add="' + v.id + '">Ajouter</button></div></li>';
        }).join('');
        up.hidden = false;
      }).catch(function () {});
    up.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cart-add]'); if (!b) return;
      e.preventDefault(); e.stopPropagation(); b.disabled = true;
      post('/cart/add.js', { items: [{ id: Number(b.getAttribute('data-cart-add')), quantity: 1 }] }).then(function () { window.location.reload(); });
    }, true);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    document.querySelectorAll('.g-coll').forEach(function (s) {
      var grid = s.querySelector('.g-coll__grid');
      s.querySelectorAll('.g-coll__view-btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          s.querySelectorAll('.g-coll__view-btn').forEach(function (b) { b.classList.toggle('is-active', b === btn); });
          if (grid) grid.setAttribute('data-grid-view', btn.getAttribute('data-view'));
        });
      });
      var about = s.querySelector('[data-coll-about]');
      var more = s.querySelector('[data-coll-more]');
      if (about && more) {
        if (about.scrollHeight <= about.clientHeight + 4) { about.classList.add('is-open'); more.hidden = true; }
        more.addEventListener('click', function () {
          var open = about.classList.toggle('is-open');
          more.setAttribute('aria-expanded', open ? 'true' : 'false');
          more.textContent = open ? 'Réduire' : 'Lire la suite';
        });
      }
      var sort = s.querySelector('[data-coll-sort]');
      if (sort) {
        sort.addEventListener('change', function () {
          var url = new URL(window.location.href);
          url.searchParams.set('sort_by', sort.value);
          url.searchParams.delete('page');
          window.location.href = url.toString();
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-gp-root]').forEach(function (root) {
      /* Gallery */
      var thumbs = root.querySelectorAll('[data-gp-thumb]');
      var heroes = root.querySelectorAll('[data-gp-hero]');
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = t.getAttribute('data-gp-thumb');
          thumbs.forEach(function (b) {
            var on = b === t;
            b.classList.toggle('is-active', on);
            b.setAttribute('aria-selected', on ? 'true' : 'false');
          });
          heroes.forEach(function (h) {
            h.classList.toggle('is-active', h.getAttribute('data-gp-hero') === idx);
          });
        });
      });

      /* Quantity */
      var qtyInput = root.querySelector('[data-gp-qty-input]');
      function setQty(n) {
        if (!qtyInput) return;
        var v = Math.max(1, Math.min(10, n || 1));
        qtyInput.value = v;
      }
      var minus = root.querySelector('[data-gp-qty-minus]');
      var plus = root.querySelector('[data-gp-qty-plus]');
      if (minus) minus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) - 1); });
      if (plus) plus.addEventListener('click', function () { setQty(parseInt(qtyInput.value, 10) + 1); });
      if (qtyInput) qtyInput.addEventListener('change', function () { setQty(parseInt(qtyInput.value, 10)); });

      /* Variants */
      var variantsScript = root.querySelector('[data-gp-variants]');
      var variantInput   = root.querySelector('[data-gp-variant-id]');
      var buyBox         = root.querySelector('[data-gp-buy]');
      var oosBox         = root.querySelector('[data-gp-oos]');
      var priceEl        = root.querySelector('[data-gp-price]');
      var stickyPrice    = root.querySelector('[data-gp-sticky-price]');
      var variantTitle   = root.querySelector('[data-gp-variant-title]');
      var optGroups      = root.querySelectorAll('[data-gp-opt-index]');
      var variants       = [];
      try { variants = JSON.parse(variantsScript ? variantsScript.textContent : '[]'); } catch (e) {}

      function currentSelection() {
        var sel = [];
        optGroups.forEach(function (group) {
          var idx = parseInt(group.getAttribute('data-gp-opt-index'), 10);
          var active = group.querySelector('.gp__pill.is-active');
          sel[idx] = active ? active.getAttribute('data-gp-opt-value') : null;
        });
        return sel;
      }
      function findVariant(sel) {
        for (var i = 0; i < variants.length; i++) {
          var match = true;
          for (var j = 0; j < sel.length; j++) {
            if (variants[i].options[j] !== sel[j]) { match = false; break; }
          }
          if (match) return variants[i];
        }
        return null;
      }
      function refreshState() {
        var v = findVariant(currentSelection());
        var available = !!(v && v.available);
        if (v) {
          if (variantInput) variantInput.value = v.id;
          if (priceEl) priceEl.textContent = v.price_money;
          if (stickyPrice) stickyPrice.textContent = v.price_money;
          if (variantTitle) variantTitle.textContent = v.title;
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        if (buyBox) buyBox.hidden = !available;
        if (oosBox) oosBox.hidden = available;
      }
      optGroups.forEach(function (group) {
        group.querySelectorAll('.gp__pill').forEach(function (pill) {
          pill.addEventListener('click', function () {
            group.querySelectorAll('.gp__pill').forEach(function (p) { p.classList.toggle('is-active', p === pill); });
            refreshState();
          });
        });
      });

      /* Avoid double submit */
      var form = root.querySelector('form[data-gp-form]');
      var addBtn = root.querySelector('[data-gp-add]');
      if (form && addBtn) {
        form.addEventListener('submit', function () {
          addBtn.disabled = true;
          var lbl = addBtn.querySelector('[data-gp-add-label]');
          if (lbl) lbl.textContent = 'Ajout en cours…';
        });
      }

      /* Sticky bar (mobile) */
      var sticky = root.querySelector('[data-gp-sticky]');
      var stickyBtn = root.querySelector('[data-gp-sticky-add]');
      if (sticky && buyBox && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            var show = !e.isIntersecting && e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', show);
            sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
            if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
          });
        });
        io.observe(buyBox);
      }
      if (stickyBtn && form) {
        stickyBtn.addEventListener('click', function () {
          if (form.requestSubmit) form.requestSubmit(); else form.submit();
        });
      }

      /* One accordion open at a time */
      /* Description : repliée au-delà de 640px, bouton « Lire la suite » */
      var descBody = root.querySelector('[data-gp-desc]');
      var descMore = root.querySelector('[data-gp-desc-more]');
      if (descBody && descMore && descBody.scrollHeight > 640) {
        descBody.classList.add('is-clamped');
        descMore.hidden = false;
        descMore.addEventListener('click', function () {
          var open = descBody.classList.toggle('is-clamped') === false;
          descMore.setAttribute('aria-expanded', open ? 'true' : 'false');
          descMore.textContent = open ? 'Réduire' : 'Lire la suite';
          if (!open) descBody.closest('details').scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      var accRoot = root.querySelector('[data-gp-accordion]');
      if (accRoot) {
        var items = accRoot.querySelectorAll('details');
        items.forEach(function (d) {
          d.addEventListener('toggle', function () {
            if (d.open) items.forEach(function (o) { if (o !== d) o.open = false; });
          });
        });
      }

      /* After a back-in-stock request, bring the confirmation into view */
      if (window.location.search.indexOf('contact_posted=true') > -1 && oosBox) {
        oosBox.scrollIntoView({ block: 'center' });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-search"]) return;
  try {
    
  (function () {
    /* Live suggestions while typing: products ranked by name match */
    var input = document.querySelector('[data-g-search-input]');
    var box = document.querySelector('[data-g-search-suggest]');
    if (!input || !box || !window.fetch) return;

    function norm(s) {
      return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
    }
    function words(s) {
      return norm(s).split(' ').filter(function (w) { return w.length > 1; }).map(function (w) {
        return (w.length > 4 && w.charAt(w.length - 1) === 's') ? w.slice(0, -1) : w;
      });
    }
    function score(title, terms) {
      var t = ' ' + norm(title) + ' ';
      var hits = 0;
      terms.forEach(function (w) { if (t.indexOf(w) > -1) hits++; });
      if (hits === terms.length) return t.indexOf(' ' + terms.join(' ')) > -1 ? 3 : 2;
      return hits > 0 ? 1 : 0;
    }
    function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }

    var timer, lastQ = '';
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      timer = setTimeout(function () {
        lastQ = q;
        var url = '/search/suggest.json?q=' + encodeURIComponent(q) +
          '&resources[type]=product&resources[limit]=10&resources[options][unavailable_products]=show&resources[options][fields]=title,product_type,tag';
        fetch(url).then(function (r) { return r.json(); }).then(function (data) {
          if (q !== lastQ) return;
          var terms = words(q);
          var items = (((data || {}).resources || {}).results || {}).products || [];
          items = items.map(function (p, i) { return { p: p, s: score(p.title, terms), i: i }; })
            .filter(function (x) { return x.s > 0; })
            .sort(function (a, b) { return b.s - a.s || a.i - b.i; })
            .slice(0, 6);
          if (!items.length) { box.hidden = true; box.innerHTML = ''; return; }
          box.innerHTML = items.map(function (x) {
            var p = x.p;
            var img = p.image ? '<img src="' + p.image + '&width=80" alt="" loading="lazy">' : '';
            var price = p.price ? Number(p.price).toFixed(2).replace('.', ',') + ' DH' : '';
            var oos = p.available === false ? '<span class="g-sug__oos">Bientôt de retour</span>' : '';
            return '<a href="' + p.url.split('?')[0] + '">' + img + '<span>' + esc(p.title) + '<br>' + oos + '</span><span class="g-sug__price">' + price + '</span></a>';
          }).join('');
          box.hidden = false;
        }).catch(function () { box.hidden = true; });
      }, 180);
    });
    document.addEventListener('click', function (e) {
      if (!box.contains(e.target) && e.target !== input) box.hidden = true;
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') box.hidden = true;
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["news-blog"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
    }, { threshold: 0.15 });
    section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-grid-tabs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section) return;
    var tabs = section.querySelectorAll('.pgt__tab');
    var panels = section.querySelectorAll('.pgt__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');
        tabs.forEach(function (t) {
          t.classList.toggle('is-active', t === tab);
          t.setAttribute('aria-selected', t === tab ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          p.classList.toggle('is-active', p.id === target);
        });
      });
    });
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["produits-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const slider = document.getElementById('productSlider');
  if (!slider) return;

  const items = slider.querySelectorAll('.product-card');
  if (items.length <= 1) return;

  // Clone items for infinite loop
  const cloneCount = Math.min(3, items.length);
  for (let i = 0; i < cloneCount; i++) {
    const clone = items[i].cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    slider.appendChild(clone);
  }

  let currentIndex = 0;
  let isAnimating = false;
  let autoScrollInterval;
  let scrollAmount = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);

  // Update scroll amount on resize
  window.addEventListener('resize', () => {
    scrollAmount = items[0].offsetWidth + parseInt(window.getComputedStyle(items[0]).marginRight);
  });

  function scrollToIndex(index) {
    if (isAnimating) return;
    isAnimating = true;
    
    slider.scrollTo({
      left: index * scrollAmount,
      behavior: 'smooth'
    });

    setTimeout(() => {
      // If we're at the clones, instantly reset without animation
      if (index >= items.length) {
        slider.style.scrollBehavior = 'auto';
        slider.scrollLeft = 0;
        currentIndex = 0;
        setTimeout(() => {
          slider.style.scrollBehavior = 'smooth';
        }, 50);
      }
      isAnimating = false;
    }, 500);
  }

  function scrollNext() {
    currentIndex++;
    scrollToIndex(currentIndex);
  }

  function scrollPrev() {
    currentIndex = Math.max(0, currentIndex - 1);
    scrollToIndex(currentIndex);
  }

  // Auto-scroll every 3 seconds
  function startAutoScroll() {
    autoScrollInterval = setInterval(scrollNext, 2500);
  }

  function stopAutoScroll() {
    clearInterval(autoScrollInterval);
  }

  // Initialize auto-scroll
  startAutoScroll();

  // Pause on hover/touch
  slider.addEventListener('mouseenter', stopAutoScroll);
  slider.addEventListener('mouseleave', startAutoScroll);
  slider.addEventListener('touchstart', stopAutoScroll, { passive: true });
  slider.addEventListener('touchend', startAutoScroll, { passive: true });

  // Arrow controls
  document.querySelector('.slider-arrow.left').addEventListener('click', scrollPrev);
  document.querySelector('.slider-arrow.right').addEventListener('click', scrollNext);

  // Touch swipe support
  let touchStartX = 0;
  let touchEndX = 0;

  slider.addEventListener('touchstart', (e) => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });

  slider.addEventListener('touchend', (e) => {
    touchEndX = e.changedTouches[0].clientX;
    handleSwipe();
  }, { passive: true });

  function handleSwipe() {
    const threshold = 50;
    if (touchStartX - touchEndX > threshold) {
      scrollNext();
    } else if (touchEndX - touchStartX > threshold) {
      scrollPrev();
    }
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["treatment-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.querySelector('[data-section-id="{{ section.id }}"]');
    if (!section) return;
    var track = section.querySelector('.tc__track');
    var prev  = section.querySelector('.tc__nav--prev');
    var next  = section.querySelector('.tc__nav--next');
    if (!track || !prev || !next) return;

    function step() {
      var first = track.querySelector('.tc__slide');
      if (!first) return 320;
      var styles = getComputedStyle(track);
      var gap = parseInt(styles.columnGap || styles.gap || 0, 10) || 0;
      return first.getBoundingClientRect().width + gap;
    }

    prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function () { track.scrollBy({ left:  step(), behavior: 'smooth' }); });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('fade-in'); io.unobserve(e.target); } });
      }, { threshold: 0.15 });
      section.querySelectorAll('.fade-in-target').forEach(function (el) { io.observe(el); });
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
